import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class OrganisationalKnowledge extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'organisationalKnowledge'}
            title={'PROCEDURE P4.0 ORGANISATIONAL KNOWLEDGE'}
            exportTitle={'<h2>Procedure P4.0 Organisational Knowledge</h2>'}
            exportFileName={'organisational_knowledge.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (OrganisationalKnowledge);